export default "__VITE_ASSET__DS_hTTQ5__"